<template>
  <v-container>
    <v-toolbar
      flat
      color="transparent"
    >
      <v-btn
        v-if="$page.props.brand === 'SBL'"
        icon
        @click="$emit('back')"
      >
        <v-icon v-text="icons.back" />
      </v-btn>
    </v-toolbar>
    <v-form
      class="mx-auto mt-4"
      style="max-width:260px"
      @submit.prevent="login()"
    >
      <v-text-field
        v-model="username"
        autocapitalize="none"
        solo
        flat
        dense
        light
        :prepend-inner-icon="icons.loginUser"
        :placeholder="__('username')"
        :readonly="sending"
        @input="showAlert = false"
      />
      <v-text-field
        v-model="password"
        solo
        flat
        dense
        light
        :prepend-inner-icon="icons.loginLock"
        :placeholder="__('password')"
        :readonly="sending"
        :append-icon="clearPassword ? icons.eye : icons.eyeOff"
        :type="clearPassword ? 'text' : 'password'"
        @click:append="clearPassword = !clearPassword"
        @input="showAlert = false"
      />
      <v-btn
        type="submit"
        block
        depressed
        color="primary"
        :loading="sending"
        :disabled="! canSubmit"
      >
        {{ __('login') }}
      </v-btn>
    </v-form>
    <v-row
      justify="center"
      class="mt-4"
      style="min-height: 72px;"
    >
      <v-alert
        v-model="showAlert"
        :icon="icons.warning"
        color="transparent"
        max-width="480"
        transition="slide-y-reverse-transition"
      >
        <span v-html="message" />
      </v-alert>
    </v-row>
  </v-container>
</template>

<script>
  import { Inertia } from '@inertiajs/inertia'
  import HandlesInertiaExceptions from '@/Mixins/HandlesInertiaExceptions'
  import I18n from '@/Mixins/I18n'
  import UsesIcons from '@/Mixins/UsesIcons'
  import Version from '@/version.json'

  export default {
    mixins: [
      HandlesInertiaExceptions,
      I18n,
      UsesIcons,
    ],

    data: () => ({
      username: '',
      password: '',
      clearPassword: false,
      sending: false,
      message: '',
      showAlert: false,
      device: {
        model: 'unknown',
        description: 'unknown',
        configured: false,
      },
      Version,
    }),

    computed: {
      canSubmit () {
        return this.username.trim() != '' && this.password != '' && this.device.configured
      },
    },

    mounted () {
      try {
        this.device.model = `${AndroidDevice.model()} - ${AndroidDevice.version()} - ${this.$page.props.brand} v${this.Version.long}`
        this.device.description = AndroidDevice.description()
        this.device.configured = true
      } catch (e) {
        this.message = 'The device is not responding'
        this.showAlert = true
      }
    },

    methods: {
      showInertiaException (message) {
        this.message = message
        this.showAlert = true
      },
      login () {
        Inertia.post('', {
          username: this.username,
          password: this.password,
          model: this.device.model,
          description: this.device.description,
        }, {
          preserveState: true,
          preserveScroll: true,
          onBefore: visit => {
            this.sending = true
            this.showAlert = false
          },
          onError: errors => this.showInertiaException(Object.values(errors).join('<br>')),
          // onSucces we do nothing because the backend will redirect for us
          onFinish: () => this.sending = false,
        })
      },
    },
  }
</script>
